export default __webpack_public_path__ + "static/media/logo2.92b73035.png";